export default "__VITE_ASSET__893a4b84__"